module.exports = __webpack_public_path__ + "static/media/welcome_pattern_no_shadow.8b825243.png";